export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/fiction.3464ba3.svg";